import { Head, useForm } from '@inertiajs/react';
import AppLayout from '@/Layouts/AppLayout';
import Card, { CardBody } from '@/Components/Card';
import Button from '@/Components/Button';
import FormInput from '@/Components/FormInput';
import FormTextarea from '@/Components/FormTextarea';
import PageHeader from '@/Components/PageHeader';
import Alert from '@/Components/Alert';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export default function Edit({ qrCode, flash }) {
    const { data, setData, put, processing, errors } = useForm({
        title: qrCode.title || '',
        description: qrCode.description || '',
        is_active: qrCode.is_active ?? true,
    });

    const submit = (e) => {
        e.preventDefault();
        put(`/qr-codes/${qrCode.id}`);
    };

    return (
        <AppLayout>
            <Head title={`Edit - ${qrCode.title}`} />
            <PageHeader
                title="Edit QR Code"
                subtitle={`Editing: ${qrCode.title}`}
                actions={
                    <Button href={`/qr-codes/${qrCode.id}`} variant="outline" size="sm">
                        <ArrowLeftIcon className="w-4 h-4" /> Back
                    </Button>
                }
            />

            {flash?.error && <Alert type="danger" className="mb-4">{flash.error}</Alert>}
            {flash?.success && <Alert type="success" className="mb-4">{flash.success}</Alert>}

            <form onSubmit={submit} className="space-y-6">
                <Card>
                    <div className="px-6 py-4 border-b border-slate-100">
                        <h3 className="font-semibold text-slate-800">QR Code Details</h3>
                    </div>
                    <CardBody>
                        <div className="space-y-6 max-w-xl">
                            <FormInput
                                label="Title"
                                value={data.title}
                                onChange={e => setData('title', e.target.value)}
                                error={errors.title}
                                required
                            />
                            <FormTextarea
                                label="Description"
                                value={data.description}
                                onChange={e => setData('description', e.target.value)}
                                error={errors.description}
                                rows={3}
                            />
                            <div>
                                <label className="flex items-center gap-3 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={data.is_active}
                                        onChange={e => setData('is_active', e.target.checked)}
                                        className="w-4 h-4 rounded border-slate-300 text-emerald-700 focus:ring-emerald-700"
                                    />
                                    <span className="text-sm font-medium text-slate-700">Active</span>
                                </label>
                                <p className="text-xs text-slate-400 mt-1 ml-7">Inactive QR codes will show a 404 page when scanned.</p>
                            </div>
                        </div>
                    </CardBody>
                </Card>

                <div className="flex gap-3">
                    <Button type="submit" disabled={processing}>
                        {processing ? 'Saving...' : 'Save Changes'}
                    </Button>
                    <Button href={`/qr-codes/${qrCode.id}`} variant="outline">Cancel</Button>
                </div>
            </form>
        </AppLayout>
    );
}
